<template>
<div class="vld-parent" ref="rootElement">
  <div>
    <form v-on:submit.prevent>
      <div class="form-group form-row">
        <label class="col-form-label col-md-1" for="tests">Tests</label>
        <select id="tests" class="form-control form-control-sm col-md-3" v-model="testId">
          <option v-for="test in tests" v-bind:value="test.id" v-bind:key="test.id">{{ test.testName}}</option>
        </select>
        <button type="button" class="col-md-1 btn btn-sm btn-info" v-on:click="autoGenerateDefinition">Auto Generate</button>
        <button type="button" class="col-md-1 btn btn-sm btn-info" v-on:click="loadDefinition">Load</button>
        <button type="button" class="col-md-1 btn btn-sm btn-success" v-on:click="saveDefinition">Save</button>
      </div>
    </form>
  </div>
  <div class="summernote"></div>
</div>
</template>

<script>
import $script from 'scriptjs';
import Utils from '@/utils.js';
import axios from 'axios';
import $ from 'jquery';
import bootstrap from 'bootstrap';

require('summernote/dist/summernote-bs4.css');
require('../assets/report-template-style.css');

export default {
  name: 'ReportTemplate',

  data () {
    return {
      summernote: null,
      testId: null,
      reportDefinitionId: null,
      tests:[]
    }
  },

  created() {

    this.tests = this.$store.getters.tests;

    $script([
      'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.11.0/umd/popper.min.js',
      'https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.10/summernote-bs4.js',
    ], 'bundle');

    $script.ready('bundle', function() {
      $script([
        // 'https://rawgit.com/creativeprogramming/summernote-addclass/master/summernote-ext-addclass.js',
        // '../assets/summernote-ext-addclass.js'
      ], 'bundle2');
    });
  },

  mounted() {
    $script.ready('bundle', function() {
      var getResultTable = function(isSingleLine) {
        var tableHTML = '<table class="testResultTable">\
        <tr>\
        <td ' + ((isSingleLine == true) ? 'class="testNameSingleLine"' : '') + '>Test Name</td>\
        <td>Result</td>\
        <td>Unit</td>\
        <td>Reference Range</td>\
        </tr>\
        </table><br/>'

        return tableHTML;
      }

      var AddSingleLineTestTemplate = function (context) {
        var ui = $.summernote.ui;

        // create button
        var button = ui.button({
          contents: 'Add single line test template',
          // tooltip: 'Add single line test template',
          click: function () {
            var html = '<div class="testBlock">' + getResultTable(true) + '</div>'
            context.invoke('code', html);
          }
        });

        return button.render();   // return button as jquery object
      }

      var AddMultiLineTestTemplate = function (context) {
        var ui = $.summernote.ui;

        // create button
        var button = ui.button({
          contents: 'Add multi line test template',
          // tooltip: 'Add multi line test template',
          click: function () {
            var html = '<div class="testBlock"><div class="testHeading">Test Heading</div>'  + getResultTable(false) + '</div>'
            context.invoke('code', html);
          }
        });

        return button.render();   // return button as jquery object
      }

        $('.summernote').summernote({
          // addclass: {
          //   debug: false,
          //   classTags: [
          //     {title: 'Test Name Single Line', value:'testNameSingleLine'},
          //     {title: 'Multi Line Test Heading', value: 'testHeading'}
          //   ]
          // },
          buttons: {
            addSingleLineTestTemplate: AddSingleLineTestTemplate,
            addMultiLineTestTemplate: AddMultiLineTestTemplate
          },
          toolbar: [
            ['style', ['style', 'addclass', 'clear']],
            ['fontstyle', ['fontname', 'fontsize', 'bold', 'italic', 'ul', 'ol', 'paragraph', 'superscript', 'subscript']],
            ['extra', ['table']],
            ['misc', ['undo', 'redo','codeview','help']],
            ['mybutton', ['addSingleLineTestTemplate', 'addMultiLineTestTemplate']],
            ['paperSize',['paperSize']]
          ],
          fontNames: [
            'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New','Helvetica', 'Garamond'
          ]
        });
    });
  },

  methods: {
    autoGenerateDefinition() {
      let loading = this.$loading.show({
        container: this.$refs.rootElement
      });

      axios.post(Utils.getURL('/reportDefinition/generate/' + this.testId))
      .then(response => {
        loading.hide();
        Utils.notifySuccess(response);
      }).catch(error => {
        loading.hide();
        Utils.notifyError(error);
      });
    },

    loadDefinition(){
      let loading = this.$loading.show({
        container: this.$refs.rootElement
      });

      axios.get(Utils.getURL('/reportDefinition/getByTestId/' + this.testId))
      .then(response => {
        loading.hide();
        var reportDefinition = response.data.results;
        this.reportDefinitionId = reportDefinition.id;
        $('.summernote').summernote('reset');
        $('.summernote').summernote('code', reportDefinition.definition);
      }).catch(error => {
        loading.hide();
        Utils.notifyError(error);
      });
    },

    saveDefinition(){
      let loading = this.$loading.show({
        container: this.$refs.rootElement
      });

      var definition = {
        id: this.reportDefinitionId,
        testId: this.testId,
        definition: $('.summernote').summernote('code')
      }

      axios.post(Utils.getURL('/reportDefinition/update'), definition, {
        params: {
            ignoreActive: true
        }
      })
      .then(response => {
        loading.hide();
        Utils.notifySuccess(response);
      }).catch(error => {
        loading.hide();
        Utils.notifyError(error);
      });
    }
  }

}

</script>
